__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "clinical-oversight-host";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(5552), __webpack_require__.e(5657), __webpack_require__.e(5731)]).then(() => (() => (__webpack_require__(5731))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(5657), __webpack_require__.e(431), __webpack_require__.e(7537)]).then(() => (() => (__webpack_require__(47537))))));
			register("@reduxjs/toolkit", "1.9.7", () => (Promise.all([__webpack_require__.e(258), __webpack_require__.e(1137), __webpack_require__.e(5606)]).then(() => (() => (__webpack_require__(60258))))));
			register("atob", "2.1.2", () => (Promise.all([__webpack_require__.e(8287), __webpack_require__.e(8470)]).then(() => (() => (__webpack_require__(28470))))));
			register("axios", "1.18.1", () => (Promise.all([__webpack_require__.e(8287), __webpack_require__.e(2630), __webpack_require__.e(3225)]).then(() => (() => (__webpack_require__(22630))))));
			register("cron-parser", "4.9.0", () => (Promise.all([__webpack_require__.e(9160), __webpack_require__.e(1296)]).then(() => (() => (__webpack_require__(59160))))));
			register("crypto", "3.12.1", () => (Promise.all([__webpack_require__.e(8287), __webpack_require__.e(1565), __webpack_require__.e(9187), __webpack_require__.e(8145), __webpack_require__.e(6383)]).then(() => (() => (__webpack_require__(91565))))));
			register("exceljs", "4.4.0", () => (__webpack_require__.e(4974).then(() => (() => (__webpack_require__(24974))))));
			register("file-saver", "2.0.5", () => (__webpack_require__.e(4213).then(() => (() => (__webpack_require__(4213))))));
			register("lodash", "4.18.1", () => (__webpack_require__.e(2543).then(() => (() => (__webpack_require__(2543))))));
			register("moment", "2.30.1", () => (Promise.all([__webpack_require__.e(6029), __webpack_require__.e(5358)]).then(() => (() => (__webpack_require__(95093))))));
			register("query-string", "7.1.3", () => (__webpack_require__.e(6663).then(() => (() => (__webpack_require__(86663))))));
			register("react-dom", "19.2.3", () => (Promise.all([__webpack_require__.e(5657), __webpack_require__.e(961)]).then(() => (() => (__webpack_require__(63342))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(1225), __webpack_require__.e(5657), __webpack_require__.e(2043), __webpack_require__.e(1233)]).then(() => (() => (__webpack_require__(61225))))));
			register("react-responsive-carousel", "3.2.23", () => (Promise.all([__webpack_require__.e(7428), __webpack_require__.e(5657), __webpack_require__.e(5556)]).then(() => (() => (__webpack_require__(27428))))));
			register("react-router-dom", "6.30.4", () => (Promise.all([__webpack_require__.e(5588), __webpack_require__.e(1080), __webpack_require__.e(5657), __webpack_require__.e(2043)]).then(() => (() => (__webpack_require__(11080))))));
			register("react-window", "1.8.11", () => (Promise.all([__webpack_require__.e(88), __webpack_require__.e(5657), __webpack_require__.e(8882)]).then(() => (() => (__webpack_require__(60088))))));
			register("react", "19.2.3", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
			register("redux-persist", "6.0.0", () => (Promise.all([__webpack_require__.e(1385), __webpack_require__.e(1137)]).then(() => (() => (__webpack_require__(41385))))));
			register("redux-saga", "1.5.0", () => (__webpack_require__.e(1782).then(() => (() => (__webpack_require__(9401))))));
			register("redux", "4.2.1", () => (__webpack_require__.e(8238).then(() => (() => (__webpack_require__(68238))))));
			initExternal(44706);
			initExternal(57686);
			initExternal(86431);
			initExternal(41983);
			initExternal(98077);
			initExternal(66972);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};